module.exports = __webpack_public_path__ + "img/banner-2026-zh-v2.c8d21de8.jpg";